import { alertDialog, filters, measures, login, } from 'i18n/ru.common';
export default {
    translation: {
        panels: {
            left: {
                find: 'Найти проект',
                title: 'Статистики',
                general: {
                    title: 'Общие статистики',
                    topProjects: 'Топ проектов',
                    trends: 'Тренды',
                },
                mostViewing: {
                    title: 'Самые просматриваемые',
                },
            },
            right: {
                title: 'Фильтрация',
            },
        },
        content: {
            subheader: {
                filter: 'Фильтр',
                allTime: 'За всё время',
                from: 'От {{formattedDate}}',
                upTo: 'До {{formattedDate}}',
                interval: {
                    yearly: 'По годам',
                    quarterly: 'По кварталам',
                    monthly: 'По месяцам',
                    weekly: 'По неделям',
                    daily: 'По дням',
                },
            },
            topProjects: {
                title: 'Лучшие Проекты',
                description: 'Лучшие проекты, появляющиеся в результатах поиска по фильтру брокеров',
            },
            trends: {
                title: 'Тренды',
                category: {
                    requests: 'Запросы',
                    emirates: 'Эмираты',
                    districts: 'Районы',
                    companies: 'Компании',
                    unit_types: 'Типы',
                    layouts: 'Комнаты',
                    unit_levels: 'Этажность',
                },
                description: 'Поиски брокеров с выбранными вами фильтрами',
                yes: 'Да',
                no: 'Нет',
                unknown: 'Неизвестно',
                noDataChart: 'Нет данных. Пожалуйста, измените фильтры чтобы увидеть статистику.',
                chartDialog: {
                    failTitle: 'Максимум 10 графиков',
                    failText: 'Вы можете добавить не более 10 графиков. Пожалуйста, удалите существующую линию, если хотите добавить новую!',
                },
                customTooltip: {
                    requests_one: '{{ count }} запрос',
                    requests_few: '{{ count }} запроса',
                    requests_many: '{{ count }} запросов',
                    requests_other: '{{ count }} запросов',
                },
                totalRequests: 'Всего запросов',
            },
            topViewersProject: {
                noDataChart: 'Нет данных. Пожалуйста, измените фильтры чтобы увидеть статистику.',
                topViewers: 'Топ просматриваемых',
                contactViews: 'Просмотры контактов',
                competitorsProjects: 'Проекты конкурентов',
            },
            topViewers: {
                title: '{{projectName}} топ просмотров',
                description: 'Лучшие агентства по количеству просмотров проектов',
                backToProject: 'Назад',
                noDataText: 'На данный момент данные недоступны. Мы работаем над добавлением новых данных в ближайшее время!',
            },
            contactViews: {
                title: '{{projectName}} просмотры контакта',
                description: 'Количество просмотров контактов проекта',
                backToProject: 'Назад',
                noDataChart: 'Нет данных. Пожалуйста, измените фильтры чтобы увидеть статистику.',
            },
            competitors: {
                title: '{{projectName}} конкуренты',
                description: 'Ваш проект среди конкурентов в результатах поиска',
                backToProject: 'Назад',
            },
            advertise: {
                start: 'Начало',
                finish: 'Конец',
                days_one: '{{count}} день',
                days_few: '{{count}} дня',
                days_many: '{{count}} дней',
                days_other: '{{count}} дней',
                notConfigured: {
                    title: 'Рекламировать этот проект',
                    description: 'Сделайте проект более заметным для клиентов, с увеличенными иконками на карте и приоритетным расположением в списке проектов.',
                    action: 'Новая реклама',
                },
                pending: {
                    title: 'Ожидание оплаты',
                    description: 'Ваша оплата не завершена. Пожалуйста, совершите оплату, чтобы активировать рекламную кампанию. Неоплаченные кампании будут автоматически удалены через 30 минут.',
                    action: 'Оплата',
                    cancel: 'Отмена оплаты',
                },
                scheduled: 'Рекламная кампания начинается',
                adPaymentStatus: {
                    successTitle: 'Успешная оплата',
                    successText: 'Рекламная кампания для {{projectName}} успешно запущена.',
                    failTitle: 'Отмена оплаты',
                    failText: 'Пожалуйста, совершите оплату, чтобы активировать рекламную кампанию. Неоплаченные кампании будут автоматически удалены через 30 минут.',
                },
            },
            editAdvertiseModal: {
                title: 'Реклама ({{ name }})',
                district: 'Район',
                unitType: 'Тип недвижимости',
                unitTypeSubtitle: 'Выберите типы юнитов, которые вы хотите продвигать.',
                layout: 'Количество спален',
                layoutSubtitle: 'Выберите, какие планировки вы хотите продвигать.',
                status: 'Статус',
                statusSubtitle: 'Выберите, какие статусы вы хотите продвигать.',
                duration: 'Продолжительность',
                durationSubtitle: 'До 30 дней',
                rate: 'Ставка',
                rateSubtitle: 'Цена за запрос',
                rateHint: 'Увеличение цены запроса повышает степень приоритетности отображения на карте',
                select: 'Выбор',
                requests: 'Запросов ({{ requests }}) × Ставка ({{ rate }}) ÷ Неделя (7) × Продолжительность ({{ duration }}) = {{ result }} AED',
                hasResale: 'Перепродажа',
                hasOffPlan: 'Наличие от застройщика',
                save: 'Сохранить',
                priceDescription: 'Итоговая цена рассчитывается на основе выбранных критериев, длительности и ставки.',
                proceedToCheckout: 'Перейти к оплате',
                moreValidation: 'Введи значение больше чем {{value}}',
                lessValidation: 'Введи значение меньше чем {{value}}',
            },
        },
        filterDropdown: {
            period: 'Период',
            allTime: 'За всё время',
            customPeriod: 'Выбрать период',
            from: 'От',
            to: 'До',
            interval: 'Интервал',
            yearly: 'Год',
            quarterly: 'Квартал',
            monthly: 'Месяц',
            weekly: 'Неделя',
            daily: 'День',
        },
        barChart: {
            noData: 'Нет данных. Пожалуйста, измените фильтры, чтобы увидеть статистику.',
        },
        login,
        common: {
            alertDialog,
            filters,
            measures,
        },
    },
};
